// extracted by mini-css-extract-plugin
export default {"ButtonContainer":"FormatToggle_ButtonContainer__fX3h3","active":"FormatToggle_active__rQZkZ"};